import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import { iamDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetJwtSsoRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getSsoJwt = async (
  instance: AxiosInstance,
  params: DefaultApiGetJwtSsoRequest
) => {
  return userApiDefaultApiFactory(instance).getJwtSso(params)
}

export const verifyPcJwtSso = async (instance: AxiosInstance) => {
  return await iamDefaultApiFactory(instance).verifyPcJwtSso()
}

// Do Not Remove this line ===@import api client===
